import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import { GeoJSONFeature } from "ol/format/GeoJSON";

interface RemnantPairProps {
	originFeature:Feature<Geometry>,
	newFeature:Feature<Geometry>,
	cookieCuttedFeature:Feature<Geometry>
}

export default class RemnantPair implements RemnantPairProps {
	public originFeature:Feature<Geometry>;
	public newFeature:Feature<Geometry>;
	
	// The actual reference of the cookie cutted feautre on the map
	public cookieCuttedFeature:Feature<Geometry>;
	
	constructor({originFeature, newFeature, cookieCuttedFeature}:RemnantPairProps) {
		this.originFeature = originFeature;
		this.newFeature = newFeature;
		this.cookieCuttedFeature = cookieCuttedFeature;
	}
}